// FAQ data — also used to generate FAQPage JSON-LD for rich snippets.
export const FAQS = [
  {
    q: "How do I get 5% off my repair?",
    a: "Book online through our website and you'll automatically receive 5% off your repair total — it's our thanks for making our team's day faster and cleaner. The discount is applied after your repair is completed.",
  },
  {
    q: "How much is the service call fee?",
    a: "Our service call fee is $99 for most appliances ($109 for refrigerators) if you decide not to proceed with the repair. If you go ahead with the repair, the service call fee is completely waived — you only pay for the repair itself.",
  },
  {
    q: "Do you offer a warranty on repairs?",
    a: "Yes. Every repair is backed by our 30-day warranty on both parts and labor. If the same issue returns within 30 days, we come back and fix it at no additional cost.",
  },
  {
    q: "How fast can you come out?",
    a: "We guarantee same-day or next-day service for most appointments in Gloucester, Camden, and North Burlington Counties.",
  },
  {
    q: "What brands and models do you service?",
    a: "We service all major appliance brands and models, including GE, LG, Samsung, Whirlpool, Maytag, Frigidaire, KitchenAid, Bosch, Sub-Zero, Viking, Wolf, and many more.",
  },
  {
    q: "What appliances do you repair?",
    a: "We repair refrigerators, ovens, stoves, ranges, dishwashers, washers, dryers, and garbage disposals.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Major Appliance Repair is fully licensed and insured in New Jersey, and every technician is certified.",
  },
  {
    q: "Do you charge for diagnostics?",
    a: "We charge a flat $99 service call fee ($109 for refrigerators) for the diagnostic visit, but it is waived in full when you choose to proceed with the repair.",
  },
  {
    q: "What areas do you serve?",
    a: "We serve South Jersey, including Voorhees, Cherry Hill, Sicklerville, Mount Laurel, Marlton, Sewell, Washington Township, Wenonah, Woodbury, and the rest of Gloucester, Camden, and North Burlington Counties.",
  },
];
